import '../styles/LandingEntryBand.css';
import React from 'react';

const ENTRY_ACTIONS = [
  {
    id: 'open-account',
    label: 'Open an account',
    href: '/sign-up',
    variant: 'primary',
  },
  {
    id: 'sign-in',
    label: 'Sign in',
    href: '/login',
    variant: 'ghost',
  },
];

function LandingEntryBand() {
  return (
    <section className="leb-band" aria-labelledby="leb-heading">
      <div className="leb-inner">
        <div className="leb-copy">
          <span className="leb-marking">Begin here</span>
          <h2 className="leb-heading" id="leb-heading">
            Your account, measured from the first entry.
          </h2>
        </div>

        <div className="leb-actions">
          {ENTRY_ACTIONS.map((action) => (
            <a
              key={action.id}
              className={`leb-btn leb-btn--${action.variant}`}
              href={action.href}
            >
              <span>{action.label}</span>
              {action.variant === 'primary' && (
                <span className="leb-btn__arrow" aria-hidden="true">
                  →
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LandingEntryBand;